import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {withFirestore, firestoreConnect, populate, isLoaded} from "react-redux-firebase";
import {CALL_DB_PATH} from "../../constants/DB_PATHS";
import {connect} from "react-redux";
import CallListItem from "../CallListItem";
import withMyCoordsHOC from "../MyCoordsHOC";

class FinishedCallsList extends Component {
    render() {
        const {readyCalls} = this.props
        if (isLoaded(readyCalls)) {
            if (readyCalls !== null && readyCalls.length !== 0) {
                return (
                    <div>
                        {Object.entries(readyCalls).map((e, i) => {
                            // To include id in the object
                            e[1]['id'] = e[0]
                            return (
                                <CallListItem data={e[1]} key={i}
                                              myCoords={{
                                                  lat: this.props.myCoords.lat,
                                                  lng: this.props.myCoords.lng
                                              }}
                                              isCompany={true}
                                              takenBy={e[1].takenBy}
                                />
                            )
                        })}
                    </div>
                )
            } else {
                return <div>No ready calls</div>
            }
        } else {
            return <div>Loading ready calls</div>
        }
    }
}


export default compose(
    connect(
        ({firebase: {auth, profile}}) => ({
            auth,
            profile,
        })
    ),
    firestoreConnect(props => {
        return [
            {
                collection: CALL_DB_PATH,
                storeAs: 'readyCalls',
                where: [
                    ['takenByCompany', '==', props.auth.uid],
                    ['active', '==', false]
                ],
               /* orderBy: [
                    ['callDate', 'desc'],

                ],*/
                populates: [{child: 'takenBy', root: 'users'}],
            }
        ]
    }),
    connect((state, props) => ({
        readyCalls: populate(state.firestore, 'readyCalls',
            [{child: 'takenBy', root: 'users'}]),
    })),
    withMyCoordsHOC,
)(FinishedCallsList)